import React from 'react';
import { IconCheckCircle } from '@components/icons';
import classNames from 'classnames';

import { StepIndicatorProps } from './step-indicator.type';

export const StepIndicator = ({ id, slug, label, active, completed, disabled, onClick }: StepIndicatorProps) => {
  return (
    <button
      data-testid={`step-indicator-button-${slug}-${id}`}
      disabled={disabled}
      className={classNames(
        'inline-flex items-center gap-2 rounded-full px-2 xs:px-3 py-2 border-2 ring-1 transition-all',
        {
          'border-inverted ring-negative': active,
          'border-inverted ring-primary': !active,
        },
        {
          'fill-dark text-negative text-subtitle-s': completed,
          'fill-tertiary text-secondary text-body-s ': !completed,
        },
        { 'cursor-not-allowed pointer-events-none text-tertiary': disabled },
        'focus:outline-nonering-negative-focus border-negative-focus',
        'hover:outline-hidden ring-negative-hover border-negative-hover'
      )}
      onClick={() => onClick(slug)}>
      <span
        data-testid={`step-indicator-content-${slug}-${id}`}
        className={classNames('justify-center align-bottom w-4 h-4 text-center text-subtitle-xs rounded-full', {
          'pt-px': !completed,
          'text-negative bg-inverse': !disabled,
          'text-tertiary bg-primary': disabled,
        })}>
        {completed ? (
          <IconCheckCircle
            data-testid={`step-indicator-icon-${slug}-${id}`}
            className='w-full h-full icon-fill-negative'
          />
        ) : (
          <span data-testid={`step-indicator-number-${slug}-${id}`}>{id}</span>
        )}
      </span>
      <span
        data-testid={`step-indicator-label-${slug}-${id}`}
        className={classNames('h-4', {
          'hidden xs:block': !active,
        })}>
        {label}
      </span>
    </button>
  );
};
